<template>
    <div>
        <transition v-if="!(stripeOpen || vippsOpen)" name="fade">
            <div class="ai-question-modal">
                <div class="modal-backdrop" @click="closeByBackdrop">
                    <div class="modal-content relative">
                        <InnerLoader v-if="isLoading" :z-index="999" />
                        <NoPaymentOverlay v-if="!isLoading" @close="closeModal" :z-index="999" />

                        <div class="modal-header" style="border-bottom: none">
                            <div class="text-right">
                                <i @click="closeModal" class="fas fa-times text-xl shadow-text-none cursor-pointer"></i>
                            </div>
                        </div>

                        <div class="modal-body">
                            <div class="text-center ai-question-header payment-popup-header">
                                <h2 class="text-xl md:text-3xl my-1 shadow-text-none">
                                    {{ translate('purchase_header_upgrade') }}
                                </h2>
                                <h4 class="mb-0 shadow-text-none text-lg mt-0 font-thin">
                                    {{ translate('purchase_header_upgrade_ai_question') }}
                                </h4>
                            </div>

                            <div class="plan-block m-auto max-w-xs">
                                <div class="plan-item system-border">
                                    <div
                                        class="flex w-full justify-center items-center p-2 plan-title system-border-bottom"
                                    >
                                        <div>
                                            <button
                                                @click="selectPrevPlan"
                                                :class="{
                                                    'system-primary-text-color': true,
                                                    'text-3xl payment-control-btn': true,
                                                    'cursor-pointer': !selectedPlanIndex == 0,
                                                    'system-primary-text-color opacity-40 cursor-not-allowed':
                                                        isFirstPlan
                                                }"
                                            >
                                                <IconMinusCircle />
                                            </button>
                                        </div>
                                        <div>
                                            <div class="text-4xl mx-3 font-bold">
                                                {{ selectedPlan.limit }}
                                            </div>
                                            <div class="text-lg text-center">
                                                {{ translate('purchase_button_questions') }}
                                            </div>
                                        </div>
                                        <div>
                                            <button
                                                @click="selectNextPlan"
                                                :class="{
                                                    'system-primary-text-color': true,
                                                    'text-3xl payment-control-btn': true,
                                                    'cursor-pointer': !isFinalPlan,
                                                    'system-primary-text-color opacity-40 cursor-not-allowed':
                                                        isFinalPlan
                                                }"
                                            >
                                                <IconPlusCircle />
                                            </button>
                                        </div>
                                    </div>
                                    <div
                                        class="text-3xl md:text-5xl mt-1 pb-1 mb-0 mx-0 text-center plan-title system-border-bottom"
                                    >
                                        <h3 class="m-0 price-text text-4xl shadow-text-none" ref="priceText">
                                            ${{ selectedPlan.price }}
                                        </h3>
                                    </div>
                                    <div class="p-4">
                                        <p class="font-size-15 text-center mb-4 has-text-balanced">
                                            {{
                                                translate('purchase_buy_ai_question_description', {
                                                    question: selectedPlan.limit,
                                                    image: selectedPlan.image_generation_limit,
                                                    price: selectedPlan.price
                                                })
                                            }}
                                        </p>
                                        <button
                                            v-if="geoLocation && geoLocation.code == 'NO'"
                                            @click="onShowVippsModal"
                                            type="button"
                                            class="btn btn-outline btn-vipps w-full font-opensans font-size-15 mb-1"
                                        >
                                            {{ translate('purchase_button_vipps') }}
                                        </button>
                                        <button
                                            @click="setStripeModal(true, accessSelected)"
                                            type="button"
                                            class="btn btn-outline btn-stripe w-full font-opensans font-size-15"
                                        >
                                            {{ translate('purchase_button_stripe') }}
                                        </button>
                                        <PaypalButton
                                            @success="paidSuccess"
                                            @creating="isLoading = true"
                                            @cancel="isLoading = false"
                                            @error="isLoading = false"
                                            :price="selectedPlan.price"
                                            class="mt-1"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <StripeCheckout
            @result="paidByStripe"
            @close="setStripeModal"
            :open="stripeTag.status"
            :title="stripeTag.item ? stripeTag.item.title : ''"
            :perUnit="stripeTag.item ? stripeTag.item.unit : ''"
            :paymentDescription="stripeTag.item ? stripeTag.item.description : ''"
            :amount="stripeTag.item ? stripeTag.item.price : 0"
        />
        <VippsPayment
            @close="closeVippsModal"
            @result="paidByVipps"
            :open="vippsData.status"
            :amount="selectedPlan.nok_amount"
            :title="
                translate('vipps_modal_title_questions', {
                    limit: selectedPlan.limit
                })
            "
            :unit-text="selectedPlan.limit + ' questions'"
            :unit="translate('vipps_modal_unit_questions', { limit: selectedPlan.limit })"
            :vipps-data="vippsData"
        />
    </div>
</template>

<script>
import appConfig from '@/app.config'
import Request from '@/lib/request'
import { currentUser } from '@/lib/user'
import popup from '@/lib/popup'
import InnerLoader from '@/components/InnerLoader'
import PaypalButton from '@/components/PaypalButton'
import VippsPayment from '@/components/VippsPayment'
import StripeCheckout from '@/components/StripeCheckout'
import UserService from '@/lib/user.js'
import helperMixin from '@/mixins/helper'
import helper from '@/lib/helper.js'
import IconPlusCircle from '../components/IconPlusCircle'
import IconMinusCircle from '../components/IconMinusCircle'
import NoPaymentOverlay from '@/components/NoPaymentOverlay'

export default {
    name: 'PaymentPopup',

    components: {
        PaypalButton,
        InnerLoader,
        StripeCheckout,
        VippsPayment,
        IconPlusCircle,
        IconMinusCircle,
        NoPaymentOverlay
    },

    mixins: [helperMixin],

    props: {
        quizId: {
            type: String
        },
        paymentTitle: {
            type: String
        },
        paymentDescription: {
            type: String
        }
    },

    data() {
        return {
            stripeOpen: false,
            vippsOpen: false,
            showCloseButton: false,
            isLoading: false,
            geoLocation: null,
            selectedPlanIndex: 0,
            stripeTag: {
                status: false,
                item: null
            },
            vippsData: {
                status: false,
                item: {}
            }
        }
    },

    computed: {
        plans() {
            return appConfig.aiQuestionPlan
        },

        selectedPlan() {
            return this.plans[this.selectedPlanIndex]
        },

        isFinalPlan() {
            return this.selectedPlanIndex + 1 == this.plans.length
        },

        isFirstPlan() {
            return this.selectedPlanIndex == 0
        },

        accessSelected() {
            if (this.plans.length > 0) {
                return this.plans[this.selectedPlanIndex]
            }
            return null
        }
    },

    mounted() {
        this.getCurrentCountry()
    },

    methods: {
        onShowVippsModal() {
            this.vippsData.status = true
        },

        setStripeModal(status = false, target = null) {
            const data = {
                status: status,
                target: target
            }

            this.checkAuthUser().then(() => {
                this.toggleLoading(false)
                if (data.target) {
                    let price = data.target.price
                    var payload = { price: price }

                    if (data.target.limit != undefined) {
                        payload['title'] = this.$t('stripe_modal_description_question', { limit: data.target.limit })
                        payload['unit'] = this.$t('stripe_modal_unit_question', { limit: data.target.limit })
                        payload['description'] = 'Upgrade questions'
                        payload['payment_on'] = 'access'
                    }
                }

                this.stripeTag = {
                    status: data.status,
                    item: payload
                }
            })
        },

        closeStripeModal() {
            this.stripeOpen = false
            this.closeModal()
        },

        closeVippsModal() {
            this.vippsData.status = false
            this.closeModal()
        },

        closeModal() {
            this.isLoading = false
            this.$emit('close')
        },

        closeByBackdrop(e) {
            if (this.isLoading) {
                return
            }

            if (!e.target.classList.contains('modal-backdrop')) {
                return
            }

            this.closeModal()
        },

        animatePrice() {
            this.$refs.priceText.style.transform = 'scale(1.5)'
            setTimeout(() => {
                this.$refs.priceText.style.transform = 'scale(1)'
            }, 400)
        },

        selectNextPlan() {
            if (this.selectedPlanIndex + 1 >= this.plans.length) {
                return
            }

            this.animatePrice()
            this.selectedPlanIndex++
        },

        selectPrevPlan() {
            if (this.selectedPlanIndex <= 0) {
                return
            }

            this.animatePrice()
            this.selectedPlanIndex--
        },

        paidByVipps(status) {
            if (status == 'RESERVE') {
                this.$emit('success', status)
                this.trackPay('vipps', 'buy_ai_question')
                popup.alert(this.translate('purchase_alert_success'), function () {}, { icon: 'success' })
            } else {
                this.closeModal()
                popup.alert(this.translate('purchase_alert_fail'), function () {}, { icon: 'error' })
            }
        },

        paidSuccess(details) {
            const selected = this.plans[this.selectedPlanIndex]

            const payload = {
                order_id: details.id,
                payer_name: `${details.payer.name.given_name} ${details.payer.name.surname}`,
                payer_email: details.payer.email_address,
                payer_id: details.payer.payer_id,
                amount: details.purchase_units[0].amount.value,
                user_id: currentUser().id,
                method: 'paypal',
                type: 'ai-question',
                data: {
                    limit_player: selected.limit
                },
                quiz_id: this.quizId
            }

            const request = new Request()

            request
                .post(appConfig.api.saveBuyPlayerOrder, payload)
                .then(() => {
                    this.closeModal()
                    this.$emit('success', payload)
                    this.trackPay('paypal', 'buy_ai_question')
                    popup.alert(this.translate('purchase_alert_success'), function () {}, { icon: 'success' })
                })
                .catch(() => {
                    this.closeModal()
                    popup.alert(this.translate('purchase_alert_fail'), function () {}, { icon: 'error' })
                })
        },

        paidByStripe(res) {
            if (res.status_code == 200) {
                const selected = this.plans[this.selectedPlanIndex]

                const payload = {
                    order_id: res.data.id,
                    payer_name: currentUser().name,
                    payer_email: currentUser().email,
                    payer_id: currentUser().id,
                    amount: parseFloat(res.data.amount / 100).toFixed(2),
                    user_id: currentUser().id,
                    method: res.data.method,
                    type: 'ai-question',
                    data: {
                        limit_player: selected.limit
                    },
                    quiz_id: this.quizId
                }

                const request = new Request()

                request
                    .post(appConfig.api.saveBuyPlayerOrder, payload)
                    .then(() => {
                        this.closeStripeModal()
                        this.$emit('success', payload)
                        this.trackPay('stripe', 'buy_ai_question')
                        popup.alert(this.translate('purchase_alert_success'), function () {}, { icon: 'success' })
                    })
                    .catch(() => {
                        this.closeStripeModal()
                        popup.alert(this.translate('purchase_alert_fail'), function () {}, { icon: 'error' })
                    })
            } else {
                this.closeStripeModal()
                popup.alert(this.translate('purchase_alert_fail'), function () {}, { icon: 'error' })
            }
        },

        isLoggedIn() {
            const userService = new UserService()
            return userService.isLoggedIn()
        },

        trackPay(payment, label) {
            helper.gTrackEvent('payed', {
                event_category: `Payed_${payment}`,
                event_label: `Pay_${label}_at_payment_popup`
            })
        },

        getCurrentCountry() {
            this.isLoading = true

            if (this.$store) {
                return this.$store.dispatch('getCurrentCountry').then(res => {
                    this.geoLocation = res.data.data
                    this.isLoading = false
                })
            }

            const request = new Request()
            const url = appConfig.api.getUserCountry

            request.get(url).then(res => {
                this.geoLocation = res.data.data
                this.isLoading = false
            })
        },

        checkAuthUser() {
            const userService = new UserService()
            this.toggleLoading(true)

            return new Promise((resolve, reject) => {
                userService
                    .validateToken()
                    .then(() => {
                        resolve()
                    })
                    .catch(() => {
                        this.openAuthPopup()
                        reject()
                    })
            })
        },

        toggleLoading(status) {
            this.$store.commit('toggleMainLoader', status)
        }
    }
}
</script>

<style lang="scss">
@import '@/scss/modal.scss';

$input-border-color: #cbcbcb;
$input-border-darker-color: #b6b6b6;

.ai-question-modal {
    .ai-question-header {
        &.payment-popup-header {
            margin-bottom: 1rem;

            @media screen and (max-width: 719px) {
                margin-bottom: 1rem;
            }
        }
    }

    .modal-backdrop {
        background-color: rgba(0, 0, 0, 0.2);
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.5rem;
        z-index: 9999;
        overflow: auto;

        .modal-content {
            background-color: #fff;
            // margin-top: 4rem;
            padding: 1rem;
            min-width: 720px;
            overflow: hidden;
            border-radius: 3px;
            box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.6);

            @media screen and (max-width: 719px) {
                min-width: 90%;
                margin: 1rem 0.5rem;
            }

            .modal-body {
                margin: 0 0 0 0;

                @media screen and (max-width: 719px) {
                    margin: 0 0 1rem 0;
                }
            }
        }
    }

    .plan-block {
        @include plan-block-modal;
    }
    .btn-outline {
        @include btn-outline;
    }

    .btn {
        border-radius: 4px;
    }

    .ai-question-modal .btn-outline,
    .btn.btn-outline {
        border: 0;
    }

    .btn-stripe {
        @include btn-stripe;
    }

    .btn-vipps {
        @include btn-vipps;
    }
}
</style>
